import {ClientBuyAndHoldIdeaService} from './com/unitedtraders/luna/mobilegateway/buyandhold/ClientBuyAndHoldIdeaService';
import {ConvertClientService} from './com/unitedtraders/luna/mobilegateway/convert/ConvertClientService';
import {DepositService} from './com/unitedtraders/luna/mobilegateway/deposit/DepositService';
import {InvoiceService} from './com/unitedtraders/luna/mobilegateway/invoice/InvoiceService';
import {ClientLimitedIdeaService} from './com/unitedtraders/luna/mobilegateway/limited/ClientLimitedIdeaService';
import {AccessRecoveryService} from './com/unitedtraders/luna/mobilegateway/recovery/AccessRecoveryService';
import {RegistrationService} from './com/unitedtraders/luna/mobilegateway/registration/RegistrationService';
import {ClientStocksService} from './com/unitedtraders/luna/mobilegateway/stocks/ClientStocksService';
import {ClientUnlimitedIdeaService} from './com/unitedtraders/luna/mobilegateway/unlimited/ClientUnlimitedIdeaService';
import {MobileApplicationVersionService} from './com/unitedtraders/luna/mobilegateway/version/MobileApplicationVersionService';
import {WithdrawService} from './com/unitedtraders/luna/mobilegateway/withdraw/WithdrawService';
import {schema} from './schema';
import {Tokens} from '@unitedtraders/keycloak';
import {BaseApiClient, ConfigOrOptions} from '@utex/base-api-sdk';
import {Logger} from 'loglevel';


export class ApiClient extends BaseApiClient {

  clientBuyAndHoldIdeaService: ClientBuyAndHoldIdeaService;

  mobileApplicationVersionService: MobileApplicationVersionService;

  accessRecoveryService: AccessRecoveryService;

  clientUnlimitedIdeaService: ClientUnlimitedIdeaService;

  clientLimitedIdeaService: ClientLimitedIdeaService;

  convertClientService: ConvertClientService;

  invoiceService: InvoiceService;

  withdrawService: WithdrawService;

  registrationService: RegistrationService;

  clientStocksService: ClientStocksService;

  depositService: DepositService;

  constructor(config: ConfigOrOptions, logger?: Logger, getTokens?: () => Promise<Tokens>, getTraceId?: () => string) {
    super(config, logger, schema, getTokens, getTraceId) 
    this.clientBuyAndHoldIdeaService = new ClientBuyAndHoldIdeaService(this.clients, this.logger, this.schema, config) 
    this.mobileApplicationVersionService = new MobileApplicationVersionService(this.clients, this.logger, this.schema, config) 
    this.accessRecoveryService = new AccessRecoveryService(this.clients, this.logger, this.schema, config) 
    this.clientUnlimitedIdeaService = new ClientUnlimitedIdeaService(this.clients, this.logger, this.schema, config) 
    this.clientLimitedIdeaService = new ClientLimitedIdeaService(this.clients, this.logger, this.schema, config) 
    this.convertClientService = new ConvertClientService(this.clients, this.logger, this.schema, config) 
    this.invoiceService = new InvoiceService(this.clients, this.logger, this.schema, config) 
    this.withdrawService = new WithdrawService(this.clients, this.logger, this.schema, config) 
    this.registrationService = new RegistrationService(this.clients, this.logger, this.schema, config) 
    this.clientStocksService = new ClientStocksService(this.clients, this.logger, this.schema, config) 
    this.depositService = new DepositService(this.clients, this.logger, this.schema, config) 
  }

}
